import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var relationshipOptions = {
  name: "1821gv5",
  styles: "display:flex;flex-direction:column;gap:8px;"
};
export var relationshipType = /*#__PURE__*/css("border:1px solid ", colors.neutral.trim.default, ";border-radius:3px;display:flex;flex-direction:row;gap:16px;");
export var relationshipRadio = {
  name: "ifjpm9",
  styles: "padding:12px;width:100%;display:flex;gap:6px;"
};